module.exports = __webpack_public_path__ + "img/124.d0de5fca.jpg";